<template>
  <div class="breadCrumb">
    <div><h3>Approvisionnement</h3></div>
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">Stock</li>
          <li class="breadcrumb-item">Approvisionnement</li>
          <li class="breadcrumb-item active" aria-current="page">Création</li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="card p-3">
    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Médicament</label>
        <select class="form-select" v-model="form.medicament" :class="{ 'is-invalid': errors.medicament }">
          <option disabled value="">-- Sélectionnez --</option>
          <option v-for="med in medicaments" :key="med.id" :value="med.id">{{ med.nom }}</option>
        </select>
        <div class="invalid-feedback">{{ errors.medicament }}</div>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Conditionnement</label>
        <select class="form-select" v-model="form.conditionnement" :class="{ 'is-invalid': errors.conditionnement }">
          <option disabled value="">-- Sélectionnez --</option>
          <option v-for="cond in conditionnements" :key="cond.id" :value="cond.id">{{ cond.nom }}</option>
        </select>
        <div class="invalid-feedback">{{ errors.conditionnement }}</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 mb-3">
        <label class="form-label">Quantité</label>
        <input type="number" class="form-control" v-model="form.quantite" :class="{ 'is-invalid': errors.quantite }">
        <div class="invalid-feedback">{{ errors.quantite }}</div>
      </div>

      <div class="col-md-4 mb-3">
        <label class="form-label">Prix d'achat (FCFA)</label>
        <input type="number" class="form-control" v-model="form.prixAchat" :class="{ 'is-invalid': errors.prixAchat }">
        <div class="invalid-feedback">{{ errors.prixAchat }}</div>
      </div>

      <div class="col-md-4 mb-3">
        <label class="form-label">Prix de vente (FCFA)</label>
        <input type="number" class="form-control" v-model="form.prixVente" :class="{ 'is-invalid': errors.prixVente }">
        <div class="invalid-feedback">{{ errors.prixVente }}</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Date d’approvisionnement</label>
        <input type="date" class="form-control" v-model="form.dateApprovisionnement" :class="{ 'is-invalid': errors.dateApprovisionnement }">
        <div class="invalid-feedback">{{ errors.dateApprovisionnement }}</div>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Date de péremption</label>
        <input type="date" class="form-control" v-model="form.datePeremption" :class="{ 'is-invalid': errors.datePeremption }">
        <div class="invalid-feedback">{{ errors.datePeremption }}</div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-4">
        <label class="form-label">Nombre par unité</label>
        <input type="number" class="form-control" v-model="form.nombreParUnite">
      </div>
      <div class="col-md-4">
        <label class="form-label">Montant total (achat)</label>
        <input type="number" class="form-control" :value="form.quantite * form.prixAchat" readonly>
      </div>
      <div class="col-md-4">
        <label class="form-label">Montant total (vente)</label>
        <input type="number" class="form-control" :value="form.quantite * form.prixVente" readonly>
      </div>
    </div>
    <div class="form-check form-switch mb-3">
  <input class="form-check-input" type="checkbox" id="enabledSwitch" v-model="form.isEnabled">
  <label class="form-check-label" for="enabledSwitch">Activer l'approvisionnement</label>
</div>

    <div class="d-flex justify-content-between">
      <button class="btn btn-secondary" @click="cancel">Annuler</button>
      <button class="btn btn-primary" @click="submitForm" :disabled="loading">
        <span v-if="loading">Enregistrement...</span>
        <span v-else>Enregistrer</span>
      </button>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      loading: false,
      medicaments: [],
      conditionnements: [],
      form: {
        medicament: '',
        conditionnement: '',
        quantite: 0,
        prixAchat: 0,
        prixVente: 0,
        nombreParUnite: null,
        dateApprovisionnement: '',
        datePeremption: '',
        isEnabled: true
      },
      errors: {}
    };
  },
  methods: {
    async loadDependencies() {
  try {
    const responseMedicaments = await api.getItems('medicaments');
    this.medicaments = responseMedicaments.data?.data || [];

    const responseConditionnements = await api.getItems('conditionnements');
    this.conditionnements = responseConditionnements.data?.data || [];
  } catch (error) {
    console.error('Erreur lors du chargement des dépendances :', error);
  }
},
    validate() {
      this.errors = {};
      if (!this.form.medicament) this.errors.medicament = 'Champ requis';
      if (!this.form.conditionnement) this.errors.conditionnement = 'Champ requis';
      if (!this.form.quantite || this.form.quantite <= 0) this.errors.quantite = 'Quantité invalide';
      if (!this.form.prixAchat || this.form.prixAchat <= 0) this.errors.prixAchat = 'Prix invalide';
      if (!this.form.prixVente || this.form.prixVente <= 0) this.errors.prixVente = 'Prix invalide';
      if (!this.form.dateApprovisionnement) this.errors.dateApprovisionnement = 'Champ requis';
      if (!this.form.datePeremption) this.errors.datePeremption = 'Champ requis';
      return Object.keys(this.errors).length === 0;
    },
    async submitForm() {

    
      if (!this.validate()) return;
      this.loading = true;
      try {
        
          console.log(this.form);
        await api.createItem('approvisionnements', {
          ...this.form,
         dateApprovisionnement: this.form.dateApprovisionnement
    ? new Date(this.form.dateApprovisionnement).toISOString()
    : null,
  datePeremption: this.form.datePeremption
    ? new Date(this.form.datePeremption).toISOString()
    : null
        });
      
        this.$router.push({ name: 'liste_approvisionnement' });
      } catch (error) {
        console.error('Erreur enregistrement', error);
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.$router.push({ name: 'approvisionnements' });
    }
  },
  mounted() {
    this.loadDependencies();
  }
};
</script>

<style scoped>
.breadCrumb {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
</style>
